import styled from 'styled-components';
export const StarSVGWrapper = styled.div `
  margin-right: 0px;
`;
//# sourceMappingURL=styles.js.map